/**
 * Secondi tra `generation_finished_at` e `BEGIN_VOTING` automatico.
 * Usato dal client (countdown) e dal server (`api-internal/jobs/round-tick.ts`).
 * Non importare da `api/_lib/…` nel browser: le URL `/api/…` sono riservate alle route server.
 */
export const POST_GENERATION_TO_VOTING_SEC = 5;
export const POST_GENERATION_DELAY_MS = POST_GENERATION_TO_VOTING_SEC * 1000;
